var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayCircleWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1976_480)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.37708 12C2.37708 17.5228 6.85423 22 12.3771 22C17.8999 22 22.3771 17.5228 22.3771 12C22.3771 6.47715 17.8999 2 12.3771 2C6.85423 2 2.37708 6.47715 2.37708 12ZM12.3771 7.75C12.7913 7.75 13.1271 8.08579 13.1271 8.5V11.5C13.1271 11.9142 12.7913 12.25 12.3771 12.25C11.9629 12.25 11.6271 11.9142 11.6271 11.5V8.5C11.6271 8.08579 11.9629 7.75 12.3771 7.75ZM11.3771 15.5C11.3771 16.0523 11.8248 16.5 12.3771 16.5C12.9294 16.5 13.3771 16.0523 13.3771 15.5V15.499C13.3771 14.9467 12.9294 14.499 12.3771 14.499C11.8248 14.499 11.3771 14.9467 11.3771 15.499V15.5Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1976_480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.377075)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCircleWarning);
export default __webpack_public_path__ + "static/media/gray-circle-warning.28425ad76f18162c1e1a632ac95c3b01.svg";
export { ForwardRef as ReactComponent };